import React, {Component} from 'react';
import PercentItem from './PercentItem';
import {FormattedMessage} from 'react-intl';

class TopLandingPage extends Component {
    render() {
        const landingMap = {};
        this.props.visits.forEach(({landing_page}) => {
            const page = landing_page && landing_page.startsWith("http") ? new URL(landing_page).pathname : '/';
            if (page.includes('orders') || page.includes('checkout')) {

            } else {
                landingMap[page] = landingMap[page] ? landingMap[page] + 1 : 1;
            }
        })
        const total = this.props.visits.length;
        const sortedArray = Object.keys(landingMap).map((key) => {
            const count = landingMap[key];
            return {title: key, count, percent: Math.round((count * 100) / total)}
        }).sort((a, b) => b.count - a.count).slice(0, 5)
        return (
            <div className={"card"}>
                <div className="card-header"><FormattedMessage id={"Landing Pages"}/></div>
                <ul className="list-group list-group-flush">
                    {
                        sortedArray.map(({title, percent}) => {
                            return <li className={"list-group-item"}>
                                <PercentItem title={title} percent={percent}/>
                            </li>
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default TopLandingPage;
